import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { Card, EcDetailsFrom, EcDetails } from 'components';
import { ExaminationCenterDetails } from '../../api/ApiClient';
import { mapAPIError } from '_helpers';
import { useLocalErrorHandler } from 'hooks';

const EcDetailsContainer = ({
    setErrorHandler,
    getEcDetails,
    regions,
    getRegions,
    clearEcDetails,
    ecDetails,
    apiError,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getRegions();
            await getEcDetails();
            setProcessing(false);
        };

        fetch();

        return () => {
            setProcessing(false);
            clearEcDetails();
        };
    }, []);

    const prepareQecInfo = (data: ExaminationCenterDetails): EcDetailsFrom => ({
        ...data,
        phones: [...data.phones.map(phone => ({ number: phone.number || '', internal: phone.internal || '' }))],
        faxes: [...data.faxes.map(fax => ({ number: fax.number || '', internal: fax.internal || '' }))],
        examinationCenterRegNumber: data.regNumber,
        agreementWithSpkfr: data.agreementWithSpkfr,
        agreementWithRs: '-',
    });

    return (
        <Card
          title="Общая информация"
          category="Общая информация ЦОК"
          apiError={apiError}
          showLoader={processing}
          show404Error={!ecDetails}
        >
            {ecDetails && (
                <EcDetails
                  initEcDetails={prepareQecInfo(ecDetails)}
                  apiErrorFailures={mapAPIError(apiError)}
                  regions={regions}
                  readOnly
                />
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    ecDetails: state.ec.ecDetails,
    regions: state.ec.regions,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getEcDetails: dispatch.ec.getEcDetailsAsync,
    clearEcDetails: dispatch.ec.clearEcDetails,
    getRegions: dispatch.ec.getRegionsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    errorsClean: dispatch.errors.clean,
});

export default connect(mapState, mapDispatch)(EcDetailsContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
